import React from "react";
import Table from "../Common/Table";
import TableFields from "../../constants/RestrictedPayoutDrivers/TableFields.json";
import { Pill } from "../../constants/assets/containers";

const RestrictedPayoutDriverList = ({ list }) => {
  const getFieldValue = (field, key) => {
    switch (key) {
      case "accounting_enabled":
      case "payout_enabled":
        return (
          <div className="flex items-center justify-center">
            <Pill isFalse={!field[key]}>{field[key] ? "Yes" : "No"}</Pill>
          </div>
        );
      default:
        return field[key] ? field[key] : "-";
    }
  };

  return (
    <Table list={list} getFieldValue={getFieldValue} fields={TableFields} />
  );
};

export default RestrictedPayoutDriverList;
